import {fetchClientIndustries, fetchMyGroupClients} from "./client";
import {fetchCompanies} from "./company";
import {fetchCities, fetchProvinces} from "./region";

const fetchHandlers = {
    clientIndustries: fetchClientIndustries,
    companies: fetchCompanies,
    myGroupClients: fetchMyGroupClients,
    provinces: fetchProvinces,
    cities: fetchCities,
};

export const getFetchHandler = (fetchKey) => {
    const handler = fetchHandlers[fetchKey];
    if (!handler) return null;
    return (...params) => handler(...params);};
